{
  "maxActive": 8,
  "dailyTimezone": "Europe/Istanbul",
  "quests": [
    {
      "id": "boar_cull",
      "name": "Tusks in the Turnips",
      "zones": ["dev_field"],
      "level": 1,
      "text": "Bristle boars are rooting up every field around the village. Thin them out.",
      "goal": {
        "kind": "kill",
        "mob": "bristle_boar",
        "count": 6
      },
      "reward": {
        "xp": 40,
        "gold": 40
      }
    },
    {
      "id": "grey_pelts",
      "name": "Grey Pelts",
      "zones": ["dev_field"],
      "level": 2,
      "text": "The tanner wants ash wolf pelts before the cold sets in.",
      "goal": {
        "kind": "collect",
        "mob": "ash_wolf",
        "count": 5,
        "item": "Ash Wolf Pelt",
        "chance": 0.6
      },
      "reward": {
        "xp": 250,
        "gold": 40
      }
    },
    {
      "id": "mire_toads",
      "name": "Croaking in the Mire",
      "zones": ["dev_field"],
      "level": 3,
      "text": "Mire toads have spread from the marsh onto the road. Drive them back.",
      "goal": {
        "kind": "kill",
        "mob": "mire_toad",
        "count": 8
      },
      "reward": {
        "xp": 470,
        "gold": 100
      }
    },
    {
      "id": "husk_hearts",
      "name": "Hearts of Stone",
      "zones": ["dev_field"],
      "level": 5,
      "text": "Stone husks carry a warm stone inside. Bring some back to study.",
      "goal": {
        "kind": "collect",
        "mob": "stone_husk",
        "count": 5,
        "item": "Husk Heart",
        "chance": 0.5
      },
      "reward": {
        "xp": 1860,
        "gold": 170
      }
    },
    {
      "id": "thornbacks",
      "name": "Thornback Trouble",
      "zones": ["dev_field"],
      "level": 8,
      "text": "Thornback boars have gored two farmhands. Put an end to it.",
      "goal": {
        "kind": "kill",
        "mob": "thornback_boar",
        "count": 10
      },
      "reward": {
        "xp": 4070,
        "gold": 280
      }
    },
    {
      "id": "road_tax",
      "name": "Road Tax",
      "zones": ["dev_field"],
      "level": 10,
      "text": "Bandits rob every cart on the road. Take back what they stole.",
      "goal": {
        "kind": "collect",
        "mob": "bandit",
        "count": 8,
        "item": "Stolen Coin Pouch",
        "chance": 0.5
      },
      "reward": {
        "xp": 8600,
        "gold": 350
      }
    },
    {
      "id": "pack_leaders",
      "name": "Pack Leaders",
      "zones": ["dev_field"],
      "level": 13,
      "text": "Without their alphas the wolf packs will scatter.",
      "goal": {
        "kind": "kill",
        "mob": "alpha_wolf",
        "count": 10
      },
      "reward": {
        "xp": 11900,
        "gold": 550
      }
    },
    {
      "id": "lurker_eyes",
      "name": "Eyes in the Water",
      "zones": ["dev_field"],
      "level": 16,
      "text": "Mire lurker eyes glow in the dark. The alchemist pays for them.",
      "goal": {
        "kind": "collect",
        "mob": "mire_lurker",
        "count": 8,
        "item": "Lurker Eye",
        "chance": 0.5
      },
      "reward": {
        "xp": 24100,
        "gold": 550
      }
    },
    {
      "id": "barrow_rest",
      "name": "Rest for the Barrows",
      "zones": ["dev_field"],
      "level": 19,
      "text": "The dead walk out of the old barrows at night. Lay them back to rest.",
      "goal": {
        "kind": "kill",
        "mob": "barrow_skeleton",
        "count": 12
      },
      "reward": {
        "xp": 27300,
        "gold": 1100
      }
    },
    {
      "id": "bear_country",
      "name": "Bear Country",
      "zones": ["human_homeland", "orc_homeland"],
      "level": 21,
      "text": "Cave bears have come down to the farms. Hunt them before winter.",
      "goal": {
        "kind": "kill",
        "mob": "cave_bear",
        "count": 12
      },
      "reward": {
        "xp": 34100,
        "gold": 1350
      }
    },
    {
      "id": "bear_claws",
      "name": "Claws for the Tanner",
      "zones": ["human_homeland", "orc_homeland"],
      "level": 23,
      "text": "Cave bear claws make the best hooks and charms.",
      "goal": {
        "kind": "collect",
        "mob": "cave_bear",
        "count": 10,
        "item": "Bear Claw",
        "chance": 0.5
      },
      "reward": {
        "xp": 53500,
        "gold": 1150
      }
    },
    {
      "id": "troll_hunt",
      "name": "Troll Hunt",
      "zones": ["human_homeland", "orc_homeland"],
      "level": 25,
      "text": "Forest trolls are raiding the woodcutters' camps.",
      "goal": {
        "kind": "kill",
        "mob": "forest_troll",
        "count": 12
      },
      "reward": {
        "xp": 50000,
        "gold": 1800
      }
    },
    {
      "id": "troll_hides",
      "name": "Mossy Hides",
      "zones": ["human_homeland", "orc_homeland"],
      "level": 27,
      "text": "Troll hide turns a blade. The armorers want all they can get.",
      "goal": {
        "kind": "collect",
        "mob": "forest_troll",
        "count": 10,
        "item": "Mossy Troll Hide",
        "chance": 0.5
      },
      "reward": {
        "xp": 76100,
        "gold": 1500
      }
    },
    {
      "id": "stone_giants",
      "name": "Stone Giants",
      "zones": ["human_homeland", "orc_homeland"],
      "level": 29,
      "text": "Granite golems block the quarry road. Break them.",
      "goal": {
        "kind": "kill",
        "mob": "granite_golem",
        "count": 12
      },
      "reward": {
        "xp": 69300,
        "gold": 2350
      }
    },
    {
      "id": "golem_cores",
      "name": "Living Rock",
      "zones": ["human_homeland", "orc_homeland"],
      "level": 31,
      "text": "Something keeps the golems moving. Bring back the shards of their cores.",
      "goal": {
        "kind": "collect",
        "mob": "granite_golem",
        "count": 10,
        "item": "Golem Core Shard",
        "chance": 0.5
      },
      "reward": {
        "xp": 103100,
        "gold": 1950
      }
    },
    {
      "id": "dire_nights",
      "name": "Dire Nights",
      "zones": ["human_homeland", "orc_homeland"],
      "level": 33,
      "text": "Dire wolves hunt the roads after dark. Hunt them first.",
      "goal": {
        "kind": "kill",
        "mob": "dire_wolf",
        "count": 14
      },
      "reward": {
        "xp": 92000,
        "gold": 3250
      }
    },
    {
      "id": "dire_pelts",
      "name": "Pelts of the Dire",
      "zones": ["human_homeland", "orc_homeland"],
      "level": 35,
      "text": "A dire wolf pelt keeps a sentry warm through the night.",
      "goal": {
        "kind": "collect",
        "mob": "dire_wolf",
        "count": 10,
        "item": "Dire Wolf Pelt",
        "chance": 0.5
      },
      "reward": {
        "xp": 134700,
        "gold": 2350
      }
    },
    {
      "id": "ogre_menace",
      "name": "Ogre Menace",
      "zones": ["human_homeland", "orc_homeland"],
      "level": 37,
      "text": "Ogre brutes are gathering at the edge of the land. Scatter them.",
      "goal": {
        "kind": "kill",
        "mob": "ogre_brute",
        "count": 14
      },
      "reward": {
        "xp": 118400,
        "gold": 4200
      }
    },
    {
      "id": "ogre_totems",
      "name": "War Totems",
      "zones": ["human_homeland", "orc_homeland"],
      "level": 39,
      "text": "Every ogre band carries a war totem. Take them and the bands lose heart.",
      "goal": {
        "kind": "collect",
        "mob": "ogre_brute",
        "count": 10,
        "item": "Ogre War Totem",
        "chance": 0.4
      },
      "reward": {
        "xp": 170900,
        "gold": 3000
      }
    },
    {
      "id": "ashes",
      "name": "Ashes to Ashes",
      "zones": ["colony_zone"],
      "level": 41,
      "text": "Ash revenants rise from the burnt ground of the Colony. Put them down.",
      "daily": true,
      "goal": {
        "kind": "kill",
        "mob": "ash_revenant",
        "count": 15
      },
      "reward": {
        "xp": 49500,
        "gold": 3750
      }
    },
    {
      "id": "grave_embers",
      "name": "Grave Embers",
      "zones": ["colony_zone"],
      "level": 43,
      "text": "The embers inside a revenant still burn. Carry some back unharmed.",
      "daily": true,
      "goal": {
        "kind": "collect",
        "mob": "ash_revenant",
        "count": 12,
        "item": "Grave Ember",
        "chance": 0.5
      },
      "reward": {
        "xp": 70600,
        "gold": 3000
      }
    },
    {
      "id": "pit_hounds",
      "name": "Hounds of the Pit",
      "zones": ["colony_zone"],
      "level": 45,
      "text": "Hellhounds run in packs through the Colony. Thin the packs.",
      "daily": true,
      "goal": {
        "kind": "kill",
        "mob": "hellhound",
        "count": 15
      },
      "reward": {
        "xp": 60700,
        "gold": 4500
      }
    },
    {
      "id": "brimstone_fangs",
      "name": "Brimstone Fangs",
      "zones": ["colony_zone"],
      "level": 47,
      "text": "Hellhound fangs are hot to the touch. The smiths want them for the forge.",
      "daily": true,
      "goal": {
        "kind": "collect",
        "mob": "hellhound",
        "count": 12,
        "item": "Brimstone Fang",
        "chance": 0.5
      },
      "reward": {
        "xp": 85900,
        "gold": 3600
      }
    },
    {
      "id": "black_glass",
      "name": "Black Glass",
      "zones": ["colony_zone"],
      "level": 49,
      "text": "Obsidian golems guard the glass fields. Break a path through.",
      "daily": true,
      "goal": {
        "kind": "kill",
        "mob": "obsidian_golem",
        "count": 15
      },
      "reward": {
        "xp": 73200,
        "gold": 5350
      }
    },
    {
      "id": "obsidian_shards",
      "name": "Obsidian Shards",
      "zones": ["colony_zone"],
      "level": 51,
      "text": "Sharp obsidian makes fine arrowheads. Bring back unbroken shards.",
      "daily": true,
      "goal": {
        "kind": "collect",
        "mob": "obsidian_golem",
        "count": 12,
        "item": "Obsidian Shard",
        "chance": 0.5
      },
      "reward": {
        "xp": 102800,
        "gold": 4250
      }
    },
    {
      "id": "cinder_wardens",
      "name": "Wardens of Cinder",
      "zones": ["colony_zone"],
      "level": 53,
      "text": "Cinder wardens stand guard over the burning ruins. Cut them down.",
      "daily": true,
      "goal": {
        "kind": "kill",
        "mob": "cinder_warden",
        "count": 16
      },
      "reward": {
        "xp": 87000,
        "gold": 6550
      }
    },
    {
      "id": "warden_sigils",
      "name": "Warden Sigils",
      "zones": ["colony_zone"],
      "level": 55,
      "text": "Each warden wears a sigil of the old fire. Take them.",
      "daily": true,
      "goal": {
        "kind": "collect",
        "mob": "cinder_warden",
        "count": 12,
        "item": "Cinder Sigil",
        "chance": 0.45
      },
      "reward": {
        "xp": 121400,
        "gold": 4900
      }
    },
    {
      "id": "molten_giants",
      "name": "Molten Giants",
      "zones": ["colony_zone"],
      "level": 57,
      "text": "Magma behemoths crawl out of the lava fields. Stop them.",
      "daily": true,
      "goal": {
        "kind": "kill",
        "mob": "magma_behemoth",
        "count": 16
      },
      "reward": {
        "xp": 102100,
        "gold": 7500
      }
    },
    {
      "id": "gloom_eyes",
      "name": "Stalkers in the Gloom",
      "zones": ["colony_zone"],
      "level": 59,
      "text": "Gloom stalkers see in the dark. Their eyes are worth a fortune.",
      "daily": true,
      "goal": {
        "kind": "collect",
        "mob": "gloom_stalker",
        "count": 12,
        "item": "Gloom Stalker Eye",
        "chance": 0.45
      },
      "reward": {
        "xp": 141600,
        "gold": 6200
      }
    },
    {
      "id": "nation_war",
      "name": "Blood for the Crown",
      "zones": ["colony_zone"],
      "level": 40,
      "text": "Defeat 100 fighters of the other nation in the Colony Zone. Kills by anyone in your party count for everyone.",
      "daily": true,
      "goal": {
        "kind": "pvp",
        "count": 100
      },
      "reward": {
        "xp": 0,
        "gold": 0,
        "np": 10000
      }
    }
  ]
}
